import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LoginService } from '../authentication/login.service';
import { ThisReceiver } from '@angular/compiler';

@Injectable()
export class CheckAuth implements CanActivate {

    loading = false;

    constructor(
        private router: Router,
        private loginService:LoginService
    ) { }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.loginService.isLoggedIn !== true) {
            this.router.navigate(['login']);
            // FE-H3: return false so the guarded route does not activate for unauthenticated users
            return false;
        }
        return true;
    }
}